// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"e0f32aab","279":"e6e7151a"}[chunkId] + ".chunk.css";
};